import { app } from '../../app.module'
app
  // アカウントの視聴回数グラフの表示
  .directive('accountView', () => {
    return {
      restrict: 'E',
      template: require('./account-view.pug')(),
    }
  })
